/*
 * @Descripttion: 上传文件
 * @Author: zenghua.wang
 * @Date: 2021-09-27 09:43:21
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 16:20:22
 */

export default {
  methods: {
    async apiUploadPicture(file, callback) {
      // 创建formdata对象
      var formData = new FormData()
      // 保存键值对
      formData.append('file', file.file)
      formData.append('returnEntity', true)
      // 上传操作
      try {
        let res = await this.$http.post('/common/document/upload', formData)
        if (res.code === 200) {
          let path = `${res.data.fastDFSGroupName}/${res.data.fastDFSPath}`
          callback && callback(path)
        }
      } catch (err) {
        this.$message.error(err.msg)
      }
    }
  }
}
